<template>
  <div>
    <div v-if="label" class="d-flex align-center">
      <slot name="prepend-inner"></slot>
      <span class="text-body-1 font-weight-bold">{{ label }}</span>
      <s-tooltip v-if="hintText" attach="parent" class="ml-1">
        <span>{{ $t(hintText) }}</span>
      </s-tooltip>
    </div>
    <v-radio-group v-bind="$attrs" :model-value="modelValue" :class="{ 'mt-0': !!label }" density="comfortable">
      <v-radio :value="yesValue" :label="$t(yesLabel)" color="primary" data-test="radio-choice-yes" />
      <v-radio :value="noValue" :label="$t(noLabel)" color="primary" data-test="radio-choice-no" />
    </v-radio-group>
  </div>
</template>

<script>
/**
 * A component that provides Yes and No radio buttons,
 * allowing the user to select one of the options.
 *
 * This component wraps the `v-radio-group` Vuetify component
 * and takes all the same props and events.
 *
 *     Label
 *
 *     (o) Yes
 *     ( ) No
 *
 * @component common/components/s-yes-no
 * @vueprop {Any} [modelValue] The v-model binding
 * @vueprop {String} [label] Optional label to be displayed above the two radio buttons
 * @vueprop {String} [yesLabel="Yes"] The label for the Yes radio
 * @vueprop {String} [noLabel="No"] The label for the No radio
 * @vueprop {String} [yesValue=1] The value for the Yes radio that will be returned through v-model
 * @vueprop {String} [noValue=0] The value for the No radio that will be returned through v-model
 *
 * @example
 *```
 * <s-yes-no
 *     mandatory
 *     required
 *     v-model="endpointServer.Active"
 *     label="Active"
 * />
 * ```
 *
 *
 * @emits change The v-model bound event. Usually this is input, but in our case it's `change`.
 * @property {Any} modelValue The text returned by v-combobox, from it's input element
 */
import STooltip from '/src/common/components/s-tooltip/s-tooltip.vue';
export default {
  // Radio group uses a custom v-model setup, emitting a
  // change event instead of input when the value changes.
  components: { STooltip },
  model: {
    event: 'change'
  },

  props: {
    // this is the v-model modelValue for the btn-toggle
    modelValue: [String, Number, Object, Boolean],

    // optional label
    label: String,

    // by default the yes button returns 1 and no returns 0
    yesValue: { type: [String, Number, Object, Boolean], default: 1 },
    noValue: { type: [String, Number, Object, Boolean], default: 0 },

    // You can customise the labels also, for example
    // if you need "OK" and "Not OK".
    yesLabel: { type: String, default: 'common.buttons.yes' },
    noLabel: { type: String, default: 'common.buttons.no' },
    hintText: { type: String, default: null }
  }
};
</script>
